export enum ProspectMutations {
  SET_SEARCH_LIST = 'SET_SEARCH_LIST',
  SET_PORTFOLIOS = 'SET_PORTFOLIOS',
  SET_PROSPECT_PORTFOLIOS_LOADING = 'SET_PROSPECT_PORTFOLIOS_LOADING',
  CLEAR_STATE = 'CLEAR_STATE',
  SET_PROSPECT_DETAILS = 'SET_PROSPECT_DETAILS',
}
